var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7598 0.148256C20.835 0.209859 20.8955 0.287379 20.937 0.375219C20.9786 0.46306 21.0001 0.559027 21 0.656193V19.0312C20.9999 19.1828 20.9473 19.3298 20.8511 19.447C20.7549 19.5643 20.6211 19.6446 20.4724 19.6743L13.9099 20.9868C13.825 21.0037 13.7375 21.0037 13.6526 20.9868L7.21875 19.7006L0.784875 20.9868C0.689704 21.0058 0.591498 21.0035 0.497333 20.98C0.403168 20.9565 0.315388 20.9124 0.240318 20.8509C0.165247 20.7894 0.104755 20.712 0.0631992 20.6243C0.0216434 20.5366 5.86067e-05 20.4407 0 20.3437L0 1.96869C9.15889e-05 1.81704 0.0527049 1.6701 0.148894 1.55285C0.245084 1.43561 0.378912 1.35529 0.527625 1.32557L7.09013 0.0130683C7.17503 -0.00390329 7.26247 -0.00390329 7.34737 0.0130683L13.7812 1.29932L20.2151 0.0130683C20.3103 -0.00607344 20.4085 -0.00387695 20.5026 0.0194995C20.5968 0.042876 20.6847 0.0868507 20.7598 0.148256ZM13.125 2.50682L7.875 1.45682V18.4931L13.125 19.5431V2.50682ZM14.4375 19.5431L19.6875 18.4931V1.45682L14.4375 2.50682V19.5431ZM6.5625 18.4931V1.45682L1.3125 2.50682V19.5431L6.5625 18.4931Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.469e032d9a60adc35c18b9c788f600cd.svg";
export { ForwardRef as ReactComponent };